import { FC } from 'react'
import { OverviewCard } from './OverviewCard'
import { useOverview } from './hooks/useOverview'
import { OverviewContainer, OverviewItemContainer } from './Overview.styles'

const Overview: FC = () => {
    const { overviewItems } = useOverview()

    return (
        <OverviewContainer data-testid="overview">
            {overviewItems.map((item) => (
                <OverviewItemContainer key={item.id}>
                    <OverviewCard {...item} />
                </OverviewItemContainer>
            ))}
        </OverviewContainer>
    )
}

export default Overview
